import React from 'react';
import {Flex} from "antd";
import {Link} from "react-router";
import styles from './DownloadMobileApp.module.scss'
// @ts-ignore
import appStoreImg from '../../assets/images/download-buttons/app-store.png'
// @ts-ignore
import googlePlayImg from '../../assets/images/download-buttons/google-play.png'

const DownloadMobileApp = () => {
  return (
    <Flex className={styles.DownloadMobileApp__wrapper} align={"center"} justify={"center"}>
      <Flex className={styles.DownloadMobileApp} vertical gap={'5px'}>
        <h1 className={styles.DownloadMobileApp__title}>Get Krankque App to continue!</h1>
        <p className={styles.DownloadMobileApp__text}>Download the app from the Apple Store or Google Play!</p>
        <Flex className={styles.DownloadMobileApp__linkSection} justify={"space-between"}>
          <Link to={'https://apps.apple.com/us/app/krankque/id6484319260'}>
            <img src={appStoreImg} alt="app store"/>
          </Link>
          <Link to={'https://play.google.com/store/apps/details?id=com.krankque.android'}>
            <img src={googlePlayImg} alt="google play"/>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DownloadMobileApp;